const mapPage = location && location.pathname == '/apps/store-locator' ? true : false;
mapPage ? document.querySelector('main').classList.add('bold-store-locator') : '';
const mapPageTitle = document.querySelector('.bold-store-locator h2')

if (mapPageTitle) {
  mapPageTitle.textContent = 'Find A Store'

  const parent = mapPageTitle.parentNode;
  const headerWrapper = document.createElement('div');
  const mapWrapper = document.createElement('div');
  const searchBarWrapper = document.createElement('div');

  const mapIframe = document.querySelector('.bold-store-locator #store_map');
  const adressesList = document.querySelector('.bold-store-locator #addresses_list');
  const directionsText = document.querySelector('.bold-store-locator #directions_text');
  const headerHtml = document.querySelector('.bold-store-locator .header_html');
  const footerHtml = document.querySelector('.bold-store-locator .footer_html');
  
  const searchBar = document.querySelector('.bold-store-locator .search_bar');
  const addressSearch = document.querySelector('#address_search');
  addressSearch.placeholder = addressSearch.value;
  const searchBarChilds = [];

  headerWrapper.classList.add('header-wrapper');
  mapWrapper.classList.add('map-wrapper');
  searchBarWrapper.classList.add('search_bar');
  searchBarWrapper.classList.add('search_wrapper');

  document.querySelectorAll('.bold-store-locator .search_bar > *').forEach((child, i) => {
    searchBarChilds.push(child);
  })
  
  // set the wrapper as child (instead of the element)
  parent.replaceChild(headerWrapper, mapPageTitle);
  parent.replaceChild(mapWrapper, mapIframe);
  searchBar.replaceChild(searchBarWrapper, document.querySelector('.bold-store-locator .search_bar > div'));

  // set element as child of wrapper
  headerWrapper.appendChild(mapPageTitle);
  headerWrapper.appendChild(headerHtml);
  mapWrapper.appendChild(mapIframe);
  mapWrapper.appendChild(adressesList);
  mapWrapper.appendChild(directionsText);
  mapWrapper.appendChild(footerHtml);

  searchBarChilds.forEach((child) => {
  searchBarWrapper.appendChild(child);
  })    
  
} 
  
setTimeout(() => {
  const allAddresses = document.querySelectorAll(".bold-store-locator #addresses_list > ul > li");
  allAddresses.forEach((add) => {
    let addName = add.querySelector('.name');
    if(addName.textContent.includes('[')){
      let newName = addName.textContent.split('[')
      addName.textContent = newName[0]
      addName.setAttribute('data-label', newName[newName.length - 1].replace(']',''))
      add.classList.add('custom-label')
    }
    setTimeout(()=>{
      add.style.display = "block"
    },1)

  })  
}, 0);  